<template>
  <div class="contanier">
    <div class="gongl-wrap">
      <div class="wrap" :class="{ clickclose: ishide }">
        <div class="close iconfont icon-close-line" @click="hide"></div>
        <div class="g-pic" @click="goShow">
          <van-image :src="gonglue" fit="cover"></van-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gonglue from "@/assets/images/gonglue.png";
export default {
  components: {},
  name: "",
  props: {},
  data() {
    return {
      gonglue,
      ishide: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.hide();
    }, 5000);
  },
  computed: {},
  methods: {
    async hide() {
      this.ishide = await true;
      let time = setTimeout(() => {
        this.$emit("hide");
        this.ishide = false;
        clearTimeout(time);
      }, 1000);
    },
    goShow(){
      this.$emit("show",true);
    }
  },
};
</script>
<style scoped lang="scss">
.contanier {
  // position: fixed;
  // top: 0;
  // width: 100%;
  // height: 100%;
  // background-color: rgba(0,0,0,.7);
  // z-index: 10;
  // max-width: var(--maxWidth);
  // margin: 0 auto;
}
.gongl-wrap {
  position: fixed;
  z-index: 10;
  // height: 252rem;
  width: 250rem;
  box-sizing: border-box;
  top: 50%;
  left: 50%;
  margin-top: -127rem;
  margin-left: -125rem;
}
.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  animation: backInRight 2s;
  &.clickclose {
    animation: backOutRight 2s;
  }
  .close {
    position: absolute;
    z-index: 3;
    right: 15rem;
    top: 0;
    padding: 5px;
    color: #fff;
    font-size: 24rem;
    cursor: pointer;
    // border-radius: 5rem;
    // background-color: rgba(0, 0, 0, 0.7);
  }
  .g-pic {
    width: 100%;
    height: 100%;
  }
}
// 弹入 往左
@keyframes backInRight {
  0% {
    -webkit-transform: translateX(2000px) scale(0);
    transform: translateX(2000px) scale(0);
    height: 0;
    opacity: 0.3;
  }

  80% {
    -webkit-transform: translateX(0px) scale(0.6);
    transform: translateX(0px) scale(0.6);
    opacity: 0.3;
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
    height: 100%;
  }
}

// 弹出 往右
@keyframes backOutRight {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  20% {
    -webkit-transform: translateX(0px) scale(0.7);
    transform: translateX(0px) scale(0.7);
    opacity: 0.7;
  }

  100% {
    -webkit-transform: translateX(700px) scale(0.7);
    transform: translateX(700px) scale(0.7);
    opacity: 0.7;
  }
}
</style>
